import useHeader from './useHeader'
import styled, { createGlobalStyle } from 'styled-components'
import { useState } from 'react'
import Link from 'next/link'
import { Media, MediaContextProvider } from '../Media'

const Header = () => {
  const { navBarAnimation, theme, pathname, navbarData } = useHeader()

  const [navOpen, setNavOpen] = useState(false)
  return (
    <MediaContextProvider>
      {/* Open/Close mechanism is only for mobile, though */}
      <StyledAbsolute className={`${navOpen ? 'open' : ''}`}>
        <StylesHeader style={navBarAnimation} className={`${theme === 'white' ? 'white-theme' : ''}`}>
          <Media lessThan='md'>
            <nav>
              <ul className='flex justify-between flex-col text-[19px]'>
                <li>
                  <Link
                    href='/awards'
                    className={pathname === '/awards' ? 'underline' : ''}
                    onClick={() => setNavOpen(false)}
                  >
                    {navbarData?.AwardsText || '{AwardsText}'}
                  </Link>
                </li>
                <li>
                  <Link
                    href='/panel'
                    className={pathname === '/panel' ? 'underline' : ''}
                    onClick={() => setNavOpen(false)}
                  >
                    {navbarData?.PanelText || '{PanelText}'}
                  </Link>
                </li>
                <li>
                  <Link
                    href='/discover'
                    className={pathname === '/discover' ? 'underline' : ''}
                    onClick={() => setNavOpen(false)}
                  >
                    {navbarData?.DiscoverText || '{DiscoverText}'}
                  </Link>
                </li>
              </ul>
            </nav>
          </Media>
          <div className='flex justify-between visible-area'>
            <StylesLogo>
              <Link href='/'>
                <img
                  src={`/svgs/ab-awards-logo-v3${theme === 'white' ? '-white' : ''}.svg`}
                  alt='AB Awards'
                  className='ab-awards-logo'
                />
              </Link>
            </StylesLogo>
            <Media lessThan='md'>
              <div className='h-full flex flex-col justify-center'>
                <StylesButton
                  className='text-base font-normal leading-none tracking-tighter align-bottom'
                  onClick={() => {
                    setNavOpen(!navOpen)
                  }}
                >
                  {navbarData?.MenuText || '{MenuText}'}
                </StylesButton>
              </div>
            </Media>
            <Media greaterThanOrEqual='md'>
              <div className='h-full flex flex-col justify-center'>
                <StylesButton>
                  <nav>
                    <ul className='flex space-x-8 font-thin'>
                      <li>
                        <Link href='/awards' className={pathname === '/awards' ? 'underline' : ''}>
                          {navbarData?.AwardsText || '{AwardsText}'}
                        </Link>
                      </li>
                      <li>
                        <Link href='/panel' className={pathname === '/panel' ? 'underline' : ''}>
                          {navbarData?.PanelText || '{PanelText}'}
                        </Link>
                      </li>
                      <li>
                        <Link href='/discover' className={pathname === '/discover' ? 'underline' : ''}>
                          {navbarData?.DiscoverText || '{DiscoverText}'}
                        </Link>
                      </li>
                    </ul>
                  </nav>
                </StylesButton>
              </div>
            </Media>
          </div>
        </StylesHeader>
      </StyledAbsolute>
      {pathname === '/' ? <GlobalStyleHomepageSnap /> : <GlobalStyle />}
    </MediaContextProvider>
  )
}

// Create global style with Styled Components
const GlobalStyleHomepageSnap = createGlobalStyle`
  html {
    @media (min-width: 1024px) {
      // scroll-snap-type: y mandatory;
    }
    overscroll-behavior-y: none;
  }
  body {
    overscroll-behavior-y: none;
  }
`

const GlobalStyle = createGlobalStyle`
  html {
    overscroll-behavior-y: none;
  }
  body {
    overscroll-behavior-y: none;
  }
`

const StyledAbsolute = styled.div`
  width: 100%;
  position: absolute;
  margin-top: -105px;
  @media (min-width: 768px) {
    margin-top: 0;
    top: 0;
    position: relative;
    height: 0;
  }
  // animate margin-top
  transition: margin-top 0.3s ease-in-out;

  &.open {
    margin-top: 0px;
  }
`

const StylesHeader = styled.header`
  top: 0;
  position: sticky;
  font-family: var(--swintonfont);

  &.white-theme {
    a {
      color: white;
    }
  }

  nav {
    text-align: center;
    background: white;
    padding: 9px;

    ul li a {
      color: #1e1e1e !important;
    }
  }

  .visible-area {
    background: white;
  }
`

const StylesLogo = styled.div`
  align-content: center;
  padding: 16px 10px 14px 14px;

  @media (min-width: 768px) {
    padding: 32px 10px 36px 30px;
  }

  img {
    height: 21.8px;
    width: auto;
    @media (min-width: 768px) {
      height: 32.7px;
    }
  }
`

const StylesButton = styled.button`
  color: #1e1e1e;
  padding: 2px 20px 0 0;
`

export default Header
